import { IconCalendarClock } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import { Alert, Group, Text } from "@/components/ui";
import { qk } from "@/lib/query-keys";
import { axiosClient } from "@/shared/api/axios-client";

interface VentanasPuePpd {
  validacionActiva: boolean;
  regimen: string;
  pueDesde: string;
  pueHasta: string;
  ppdDesde: string;
  ppdHasta: string;
}

const fmt = (iso: string) => new Date(`${iso}T00:00:00`).toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric" });

/**
 * Banner informativo (P41 · D-1) · muestra las ventanas de recepción PUE/PPD
 * vigentes ANTES de cargar el CFDI. El backend calcula las fechas con las
 * mismas fórmulas de la validación, así que lo que se anuncia aquí es
 * exactamente lo que se va a validar. Si la validación está desactivada
 * (RN-01) o la consulta falla, no se muestra nada.
 */
export function VentanasPuePpdBanner({ solicitudId }: { solicitudId: string }) {
  const { data } = useQuery({
    queryKey: qk.ventanasPuePpd(solicitudId),
    queryFn: () => axiosClient.get<VentanasPuePpd>(`/api/solicitudes/${solicitudId}/ventanas-pue-ppd`).then((r) => r.data),
    staleTime: 5 * 60_000,
  });

  if (!data?.validacionActiva) return null;

  return (
    <Alert variant="info" icon={<IconCalendarClock size={18} />} title="Ventanas de recepción por método de pago">
      <Group gap="xl" wrap="wrap">
        <Text size="sm">
          <Text span fw={600}>
            PUE
          </Text>{" "}
          (pago en una exhibición): CFDIs timbrados del {fmt(data.pueDesde)} al {fmt(data.pueHasta)}.
        </Text>
        <Text size="sm">
          <Text span fw={600}>
            PPD
          </Text>{" "}
          (pago en parcialidades, forma 99): CFDIs timbrados del {fmt(data.ppdDesde)} al {fmt(data.ppdHasta)}.
        </Text>
      </Group>
    </Alert>
  );
}
